module.exports = __webpack_public_path__ + "img/masthead4.7e9f886e.jpg";